const LineLogo = ({ white = false }) => (
  <svg viewBox="0 0 64 64">
    <path
      d="M32 8C18.2 8 7 17.2 7 28.5c0 10.1 8.9 18.6 20.8 20.2l-1.2 7c-.2 1.1 1 1.9 1.9 1.3l10.5-7.5C50.3 47.7 57 39 57 28.5 57 17.2 45.8 8 32 8Z"
      fill={white ? '#fff' : '#06C755'}
    />

    {!white && (
      <text
        x="32"
        y="34"
        textAnchor="middle"
        fill="#fff"
        fontSize="11"
        fontWeight="800"
        fontFamily="Arial, sans-serif"
      >
        LINE
      </text>
    )}

    {white && (
      <text
        x="32"
        y="34"
        textAnchor="middle"
        fill="#083b66"
        fontSize="11"
        fontWeight="800"
        fontFamily="Arial, sans-serif"
      >
        LINE
      </text>
    )}
  </svg>
);

export default LineLogo;
